
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getFullTag } from './measurements/neve-measurements-tag.service';
import { TagpairState } from './neve-measurements-table.component';
import { sum, last } from 'lodash';
import { ValmetDnaTag } from './valmet-dna.service';

export type TableRowUngrouped = {
  description: string
  value?: {
    formatted: string
    numeric: number
    ts: string
  },
  tag: ValmetDnaTag
  requestedFullTag: string
};

export type TableDataUngrouped = {
  tableType: 'ungrouped'
  rows?: TableRowUngrouped[]
  totalValueSum: string
};

export const createTableDataUngrouped = (sortedRows$: Observable<{
  tagpairStates: TagpairState[];
  sortedRows: TableRowUngrouped[];
}>) => {
  return sortedRows$.pipe(
    map(obj => {
      const { sortedRows, tagpairStates } = obj;
      const totalValueSum = calculateTotalValueSum(tagpairStates);
      return {
        tableType: 'ungrouped',
        rows: sortedRows,
        totalValueSum: totalValueSum ? totalValueSum.toFixed(0) : undefined
      } as TableDataUngrouped;
    })
  );
};

export const getTableRowUngrouped = (tagpairState: TagpairState): TableRowUngrouped => {
  const description = getFullTag(tagpairState.tagpair);
  const { state } = tagpairState;
  const tagInfo = {
    tag: state.metadata.tag,
    requestedFullTag: state.metadata.requestedTag.fullTag
  };

  if (!state.transformedMeasurements) {
    return {
      description,
      value: undefined,
      ...tagInfo
    };
  }

  const lastTrendValue = last(state.transformedMeasurements);

  return {
    description,
    value: {
      formatted: lastTrendValue?.numericValue?.toFixed(2),
      numeric: lastTrendValue?.numericValue,
      ts: lastTrendValue.ts,
    },
    ...tagInfo
  };
};

const calculateTotalValueSum = (tagpairStates: TagpairState[]) => {
  const allMeasurements = tagpairStates
    .filter(tps => tps.state.status === 'loaded' && !!tps.state.transformedMeasurements)
    .map(tps => last(tps.state.transformedMeasurements))
    .flatMap(value => value.numericValue);
  return allMeasurements.length > 0 ? sum(allMeasurements) : undefined;
};
